export const Funcoes = {
    LimitaCaracteres: (event, setState, length) => {
        const input = event.target.value

        if
            (
            (input.length <= length && !input) ||
            (input[input.length - 1].match("[0-9]") && input[0].match("[0-9]"))
        ) {
            return setState(input)
        }
    },
    LimitChar: (nChar, str) => {
        if (str.length > Number(nChar)) {
            return str.substring(0, Number(nChar)) + '...'
        }
        else {
            return str
        }
    },
    RemoveTodasTagsHTML: (str) => {
        return str.replace(/<[^>]*>/g, '')
    },
    MensagensValidacoes: message => {
        switch (message) {
            case '"value" must be a valid date':
                return 'Data inválida'

            case '"value" must be a valid email':
                return 'O e-mail não está em um formato válido'

            case '"value" must be a string':
            case '"email" is not allowed to be empty':
            case '"value" is not allowed to be empty':
                return 'O campo é obrigatório'

            case '"value" must be a safe number':
                return 'Os números não estão em um formato válido'

            case '"value" must be greater than or equal to 10':
                return 'O campo deve ter no mínimo 10 caracteres'

            default:
                return message
        }
    },
    DateIsValid: (date) => {
        const dateFormat = new Date(date)
        return dateFormat instanceof Date && !isNaN(dateFormat);
    },
    VerificaIntegridadeDataNascimento: (dataNascimento) => {
        if (dataNascimento === null || dataNascimento === undefined || dataNascimento === '') {
            return false
        }

        const dataAtual = new Date()
        const dataNascimentoDate = new Date(dataNascimento)
        const dataNascimentoDateMais16Anos = new Date(dataNascimentoDate.setFullYear(dataNascimentoDate.getFullYear() + 16))
        return dataNascimentoDateMais16Anos <= dataAtual && dataNascimentoDateMais16Anos >= dataNascimentoDate
    },
    ConverteBytesMegaBytes: bytes => (bytes / 1000 / 1000),
    ConverteDataHora: date => {
        const d = new Date(date);
        return d.toLocaleString()
    },
    ConverteSomenteDataHora: date => {
        const d = new Date(date);
        return (d.toLocaleString()).slice(0, 10)
    },
    ConverteData: date => {
        if (Funcoes.DateIsValid(date)) {
            return new Date(date).toJSON().slice(0, 10)
        } else {
            return date
        }
    },
    VerificaIntervaloData: (date, days) => {
        if (date === null) {
            return false
        }

        const data = new Date(date)
        const dataAtual = new Date()

        const diffTime = Math.abs(dataAtual - data)
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))

        return !(diffDays > days);
    },
    SanitizaCPFCNPJ: cpfCnpj => {
        if (cpfCnpj) {
            return cpfCnpj.replaceAll(/[^\d]+/g, '')
        } else {
            return cpfCnpj
        }
    },
    Capitalize: (str) => {
        if (str !== undefined && str !== null) {
            var splitStr = str.toLowerCase().split(' ');
            for (var i = 0; i < splitStr.length; i++) {
                splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
            }
            return splitStr.join(' ');
        } else {
            return str
        }
    },
    GetFirstLetter: (str) => {
        if (str !== undefined && str !== null && str !== '') {
            return str.charAt(0)
        } else {
            return str
        }
    },
    MascaraCPF: (cpf) => {
        if (cpf) {
            return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4');
        } else {
            return cpf
        }
    },
    MascaraCNPJ: (cnpj) => {
        if (cnpj) {
            return cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '$1.$2.$3/$4-$5');
        } else {
            return cnpj
        }
    },
    VerificaEspacosEmBranco: (str) => {
        if (str) {
            return str.trim() === ''
        } else {
            return false
        }
    },
    ErrorMessage: (error, enqueueSnackbar, snackbarAutoHideDuration) => {
        try {
            const validacoes = error.response.data.validacoes
            switch (error.response.status) {
                case 400:
                    try {
                        let mensagem = ''
                        validacoes.forEach(validacao => {
                            mensagem += '\n' + validacao.mensagem + ';'
                        })
                        enqueueSnackbar(mensagem, { variant: 'error', snackbarAutoHideDuration })
                    } catch (error) {
                        enqueueSnackbar('Erro ao realizar a operação ' + error, { variant: 'error', snackbarAutoHideDuration })
                    }
                    break

                case 500:
                    enqueueSnackbar('Erro ao realizar a operação' + error, { variant: 'error', autoHideDuration: snackbarAutoHideDuration })
                    break

                default:
                    enqueueSnackbar('Ocorreu um erro inesperado. Contate o suporte' + error, { variant: 'error', autoHideDuration: snackbarAutoHideDuration })
            }
        } catch (error) {
            enqueueSnackbar(error, { variant: 'error', autoHideDuration: snackbarAutoHideDuration })
        }
    }
}